import { Organization as BaseOrganization } from './';
import content from '../about/en.json';
import { AwardNames } from './awards';

const SITE_URL = 'https://loadsmart.com/';
const PAGE_URL = `${SITE_URL}about/`;

// Text values come from datafiles/about/en.json and the awards from
// datafiles/awards/list.js (via ./awards), so the schema stays in sync with
// the page (Google requires the FAQPage to match the visible FAQ word for word).
export const AboutSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      '@id': `${PAGE_URL}#webpage`,
      url: PAGE_URL,
      name: content.meta.title,
      description: content.meta.description,
      inLanguage: 'en-US',
      isPartOf: { '@id': `${SITE_URL}#website` },
      about: { '@id': `${SITE_URL}#organization` },
      mainEntity: { '@id': `${SITE_URL}#organization` },
      breadcrumb: { '@id': `${PAGE_URL}#breadcrumb` },
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}#website`,
      url: SITE_URL,
      name: 'Loadsmart',
      publisher: { '@id': `${SITE_URL}#organization` },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}#organization`,
      name: BaseOrganization.name,
      legalName: 'Loadsmart Inc.',
      url: SITE_URL,
      description: content.hero.copy,
      logo: BaseOrganization.logo,
      foundingDate: '2014',
      foundingLocation: {
        '@type': 'Place',
        name: 'New York City, New York',
      },
      founder: [
        { '@type': 'Person', name: 'Felipe Capella' },
        { '@type': 'Person', name: 'Ricardo Salgado' },
      ],
      numberOfEmployees: { '@type': 'QuantitativeValue', minValue: 500 },
      address: BaseOrganization.address,
      contactPoint: BaseOrganization.contactPoint,
      subOrganization: [
        {
          '@id': 'https://opendock.com/#organization',
          name: 'Opendock',
          url: 'https://opendock.com/en/',
        },
        {
          '@id': 'https://shipperguide.com/#organization',
          name: 'ShipperGuide',
          url: 'https://shipperguide.com/',
        },
      ],
      sameAs: BaseOrganization.sameAs,
      award: AwardNames,
    },
    {
      '@type': 'BreadcrumbList',
      '@id': `${PAGE_URL}#breadcrumb`,
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: 'About', item: PAGE_URL },
      ],
    },
    {
      '@type': 'FAQPage',
      '@id': `${PAGE_URL}#faq`,
      mainEntity: content.faq.items.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ],
};
